import React, { useCallback } from "react";
import LogDisplay from "components/Interactions/LogDisplay";
import { eventLogAPI } from "api/Interactions/EventsAPI";
import { Column } from "components/Data/DataDisplays/GenericTable";

interface EventsBottomDrawerProps {
  eventId: number;
}

const EventsBottomDrawer: React.FC<EventsBottomDrawerProps> = ({ eventId }) => {

  const fetchLogs = useCallback(() => eventLogAPI.getAllByParentId(eventId), [eventId]);

  const columns: Column<any>[] = [
    { field: "timestamp", label: "Timestamp", type: "datetime" },
    { field: "people.first_name", label: "First Name", type: "text" },
    { field: "people.last_name", label: "Last Name", type: "text" },
    { field: "notes", label: "Notes", type: "text" },
  ];
  
  return (
    <LogDisplay
      fetchLogs={fetchLogs}
      columns={columns}
      title="Event Attendance Logs"
    />
  );
};

export default EventsBottomDrawer;
